import React from 'react';
import { useSelector } from 'react-redux';
import Client from '../components/Client';
import CustomerSelect from '../components/CustomerSelect';
import ExtensionSelect from '../components/ExtensionSelect';
import UserLevelError from '../components/UserLevelError';
import WebRTCDisabled from '../components/WebRTCDisabled';
import Loading from './Loading';
const App = () => {
    const activeCustomerId = useSelector((state) => { var _a; return (_a = state.client.activeCustomer) === null || _a === void 0 ? void 0 : _a.id; });
    const accessLevel = useSelector((state) => { var _a; return (_a = state.user.user) === null || _a === void 0 ? void 0 : _a.accessLevel; });
    const loading = useSelector((state) => state.client.isFetchingLinkedUsers || state.extension.isFetching);
    const extension = useSelector((state) => state.extension.extension);
    const hasWebRTCEnabledExtensions = useSelector((state) => state.contacts.phones.some((p) => !!p.webRTCEnabled));
    const isBrandingInitialized = useSelector((state) => state.branding.isInitialized);
    // TODO_V2 handle branding errors
    // TODO spinner or something?
    if (!isBrandingInitialized) {
        return null;
    }
    const allowedAccessLevels = ['EXTENSION', 'CUSTOMER'];
    const userCanAccess = allowedAccessLevels.includes(accessLevel || '');
    if (loading) {
        return React.createElement(Loading, null);
    }
    else if (!userCanAccess) {
        return React.createElement(UserLevelError, null);
    }
    else if (extension && !extension.webRTCEnabled) {
        if (accessLevel === 'CUSTOMER' && hasWebRTCEnabledExtensions) {
            return React.createElement(ExtensionSelect, null);
        }
        else {
            return React.createElement(WebRTCDisabled, null);
        }
    }
    else if (activeCustomerId) {
        return React.createElement(Client, null);
    }
    return React.createElement(CustomerSelect, null);
};
export default App;
